import { Button, Grid, Stack } from '@mui/material';
import { useMemo } from 'react';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import BlockData from '../../../models/BlockData';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import BlockImageListData from './BlockImageListData';
import CloseButton from '../../Buttons/Close';
import GridWithSettings from '../../Layout/GridWithSettings';
import BlockImageListItemData from './BlockImageListItemData';
import BlockImageListItem from './components/BlockImageListItem';
import config from '../../../config';

export interface BlockImageListProps extends BlockProps {
  blockData: BlockData[]
}

function BlockImageList({
  data, isEditing, isTemplate, editHandler, blockData,
}: BlockImageListProps) {
  const props = (data.data as BlockImageListData);

  const handleAddImage = () => {
    props.imageList.push(BlockImageListItemData.getDefault(config.defaultImageUrl));
    editHandler(data.id, props);
  };

  const imageMenu = useMemo(() => {
    if (props.imageList && props.imageList.length > 0) {
      return props.imageList.map((item, index) => (
        <Grid key={item.id} minWidth={150} item xs={3} sx={Utils.hoverBorder(isEditing)} onClick={(event) => event.stopPropagation()}>
          <CloseButton
            show={isEditing}
            updateHandler={() => {
              props.imageList.splice(index, 1);
              editHandler(data.id, props);
            }}
          />
          <BlockImageListItem
            isTemplate={isTemplate}
            isEditing={isEditing}
            item={item}
            blockData={blockData}
            onUpdate={(newItem) => {
              props.imageList[index] = newItem;
              editHandler(data.id, props);
            }}
          />
        </Grid>
      ));
    }
    return [];
  }, [data.id, editHandler, isEditing, isTemplate, props, blockData]);

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        overflow: 'hidden',
        p: 1.5,
      }}
    >
      <GridWithSettings
        settings={props.settings}
        isEditing={isEditing}
        direction="row"
        updateHandler={(settings) => {
          props.settings = settings;
          editHandler(data.id, props);
        }}
      >
        {imageMenu}
      </GridWithSettings>
      {isEditing && (
        <Stack spacing={0} sx={{ border: '1px dashed lightGray', marginTop: '12px', width: 'calc(100% - 24px)' }}>
          <Button color="primary" onClick={handleAddImage}>
            <AddCircleRoundedIcon />
          </Button>
        </Stack>
      )}
    </Grid>
  );
}

export default BlockImageList;
